import { PRESCRIPTION_INITIATORS } from '@/services/agent-group';

export default {
  list() {
    return this.isMemberOf(PRESCRIPTION_INITIATORS);
  },
};
